import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class BusinessesService {
  constructor(private http: HttpClient) {}

  getAllBusinesses(data) {
    return this.http.post(`${environment.apiUrl}/businesses/all`, data).pipe();
  }

  createBusiness(data) {
    return this.http.post(`${environment.apiUrl}/business/create`, data).pipe();
  }

  updateBusiness(id, data) {
    return this.http
      .patch(`${environment.apiUrl}/business/update/${id}`, data)
      .pipe();
  }

  deleteBusiness(id) {
    return this.http
      .delete(`${environment.apiUrl}/business/delete/${id}`)
      .pipe();
  }

  getAllBusinessCategories(data) {
    return this.http
      .post(`${environment.apiUrl}/business-categories/all`, data)
      .pipe();
  }

  createBusinessCategory(data) {
    return this.http
      .post(`${environment.apiUrl}/business-categories/create`, data)
      .pipe();
  }

  updateBusinessCategory(id, data) {
    return this.http
      .patch(`${environment.apiUrl}/business-categories/update/${id}`, data)
      .pipe();
  }

  deleteBusinessCategory(id) {
    return this.http
      .delete(`${environment.apiUrl}/business-categories/delete/${id}`)
      .pipe();
  }

  getAllBusinessBanners(data) {
    return this.http
      .post(`${environment.apiUrl}/business-banners/all`, data)
      .pipe();
  }

  createBusinessBanner(data) {
    return this.http
      .post(`${environment.apiUrl}/business-banners/create`, data)
      .pipe();
  }

  deleteBusinessBanner(id) {
    return this.http
      .delete(`${environment.apiUrl}/business-banners/delete/${id}`)
      .pipe();
  }
}
